
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 31.13 31.15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.15 23.9l1-.64-.63-1.05L19.14 2.76 17.56 0l-2 2.65-14 18.72L0 23.42l1.49.62h.06l15.67 6.27 2 .81.55-.35.23-.15.1-.06 9.94-6.63zm-12.43 3.87l-9-3.6h8.79zm9.43-6.18h-7.24l-.87-13.9zM16.35 5.9l1 15.67H4.56zm8.79 18.25l-4.87 3.24-.2-3.24z"}})])
          )
        }
      }
    